import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';

let hash = null;
if(window.location.hash) hash = window.location.hash.replace(/^#+/i, '');

class Tabs extends PureComponent {
    static propTypes = {
        children: PropTypes.instanceOf(Array).isRequired,
    }

    constructor(props) {
        super(props);

        this.state = {
            activeTab: props.activeTab,
        }

        if (!this.props.activeTab) {
            for(let child of this.props.children){
                if(child.props){
                    // Set the first unempty child as 'current' tab. then break out of loop
                    this.state = { activeTab: child.props.tabkey};
                    break;
                }
            }
        }

        if(window.location.hash != ''){
            if(window.location.hash) hash = window.location.hash.replace(/^#+/i, '');
            if(hash) this.state = {activeTab: hash};
        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {currentTab} = this.props;

        if(hash) this.scrollToTab(hash);

        // console.log('CURRENTPROPS : | ' + currentTab + ' | PREVPROPS : | ' + prevProps.currentTab );

        if(this.props.currentTab && (prevProps.currentTab !== this.props.currentTab)){
            this.onClickTabItem(currentTab);
        }
    }

    scrollToTab = (tab) => {
        const tabElement = document.getElementById(tab);
        if(tabElement){
            tabElement.scrollIntoView({behavior: 'smooth'});
        }
    }

    onClickTabItem = (tab) => {

        this.setState({activeTab: tab}, () => {
            (this.props.reset) ? this.props.reset() : null;
           if(window.innerWidth < 760){
               this.scrollToTab(tab)
              // document.getElementById(tab).scrollIntoView({"block":"center"})
           }

        });
    }

    render() {
        const {
            onClickTabItem,
            props: {children},
            state: {activeTab}
        } = this;

        return (
            <div className="tabs">
                <ol className="tabs__list">
                    {children.map((child) => {
                        if(!child || !child.props) return null;

                        const {label, tabkey} = child.props;
                        let tab = (
                            <Tab
                                activeTab={activeTab}
                                tabkey={tabkey}
                                key={label}
                                label={label}
                                onClick={() => onClickTabItem(tabkey)}
                            />
                        );
                        if(child.props.hidden){
                            tab = null;
                        }
                        return (tab);
                    })}
                </ol>
                <div className="tabs__content">
                    {children.map((child) => {
                        if(!child || !child.props) return null;

                        let {children,tabkey,hidden} = child.props;
                        if(tabkey !== activeTab) return undefined;
                        if(hidden) children = null;

                        return children;
                    })}
                </div>
            </div>
        );
    }
}

export default Tabs;
